<template>
  <div class="text-center" style="padding: 16px;">
    <QuizJoinGameForm v-if="isAudienceFormShowing" />
    <div v-else>
      <p class="mb-4 mt-0">
        {{ $t("slideQRCodeAudience") }}
      </p>

      <div class="div-image-qrcode">
        <img :src="img" alt="" v-if="img">
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Config from '@/config'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'
import { mapState } from 'vuex'

export default {
  components: {
    QuizJoinGameForm,
  },
  data() {
    return {
      img: '',
    }
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      audienceName: (state) => state.audienceName,
      audienceEmoji: (state) => state.audienceEmoji,
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
      textColour: (state) => state.slide.textColour,
      chosenTeam: (state) => {
        return state.presentation.teamData ?
          state.presentation.teamData.find((team) => team.id === state.audienceQuizTeam) : {}
      },
    }),
    hasQuizSlides() {
      return this.$store.state.slides &&
          this.$store.state.slides.length > 0 &&
          this.$store.state.slides.some((slide) => slide.type === 'pickAnswer')
    },
    isAudienceFormShowing() {
      if (!this.hasQuizSlides) return false
      if (this.$store.state.presentation.teamPlay) {
        return (
          !this.$store.state.audienceName ||
              !this.$store.state.isAudienceEmojiDisabled ||
              !this.$store.state.audienceQuizTeam
        )
      }
      return (
        !this.$store.state.audienceName ||
            !this.$store.state.isAudienceEmojiDisabled
      )
    },

  },
  mounted() {
    const text =
      `${Config.audienceUrl}/${this.$store.state.presentation.uniqueAccessCode}`
    const self = this
    QRCode.toDataURL(
      text,
      { errorCorrectionLevel: 'Q', width: 800, margin: 1 },
      (err, url) => {
        self.img = url
      },
    )
    this._joinGame()
  },
  methods: {
    _joinGame() {
      if (this.hasQuizSlides && this.audienceName) {
        this.$http
          .post(Config.api.joinPresentation, {
            a: this.audienceId,
            n: this.audienceName,
            e: this.audienceEmoji,
            c: this.presentation.uniqueAccessCode,
            i: this.slide.id,
            t: this.audienceQuizTeam,
          })
          .then(
            () => {},
            () => {},
          )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  font-size: 18px;
}

.div-image-qrcode {
  max-width: 30%;
  margin: 0 auto 16px auto;
}
img {
  max-width: 100%;
  width: 100%;
}

@media (max-width: 800px) {
  .div-image-qrcode {
    max-width: 30%;
  }
}
</style>
